<template>
  <div>
    <sdui-loader v-if="$wait.waiting('fetching-contact-person')" />
    <SList v-else-if="contactPersons.length" :title="$t(`${translationDynamicPath}.list.title`)">
      <SListItem
        v-for="partner in contactPersons"
        :key="partner.meta.displayname"
        :title="partner.meta.displayname"
        :description="$t(`${translationDynamicPath}.list.item_description`)"
        icon="icon-user-teacher"
        icon-color="type-teacher"
        data-cy="contact-person"
      />
    </SList>
  </div>
</template>

<script>
import { waitFor } from 'src/config/setup/plugins/waitFor/index.js'
import Schools from 'src/api/schools.js'
import SduiLoader from 'src/components/miscellaneous/ui/common/SduiLoader.vue'

export default {
  name: 'SduiContactPersonsList',
  components: { SduiLoader },
  props: {
    translationRootPath: {
      type: String,
      default: '',
    },

    isAccountDeletion: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    contactPersons: [],
  }),

  computed: {
    school() {
      return this.$store.state.school || this.$me?.school
    },

    translationDynamicPath() {
      return this.translationRootPath || 'login.activation_code.contact_persons'
    },
  },

  emits: ['set-contact-person'],

  methods: {
    fetchPartnersByUuid: waitFor('fetching-contact-person', async function (uuid) {
      const { data } = await Schools.getSduiPartners(uuid)
      this.contactPersons = data || []
      if (!this.isAccountDeletion) return
      this.$emit('set-contact-person', this.contactPersons)
    }),
  },

  watch: {
    'school.uuid': {
      handler: async function (uuid) {
        if (!uuid && !this.contactPersons.length) return
        await this.fetchPartnersByUuid(uuid)
      },

      immediate: true,
    },
  },

  created() {},
}
</script>
